<template>
  <div class="personHome">
    <div class="topTitle bd10 p3">
      <div class="sTitle d-flex a-center j-sb">
        <h3 class="font20">{{ $t('adminMenu.feedback') }}</h3>
        <a class="link font-light cor999" @click="$router.go(-1)" href="javascript:;">{{ $t('admin.back') }} &gt;</a>
      </div>
    </div>

    <div class="psLeftContent">
      <div class="item">
        <div class="text bd10 p3">
          <div class="sdesc line-sm font-light">
                  <div class="txt d-flex j-sb">
                    <div class="p">
                      <b>{{ content.type }}</b>
                      <div class="pt">{{ $t('feedback.type') }}</div>
                    </div>
                    <div class="p">
                      <b>{{ content.workItemId }}</b>
                      <div class="pt">{{ $t('admin.workOrderId') }}</div>
                    </div>
                    <div class="p">
                      <b>{{ content.costomerPriority|valueToLabel(selectPriority) }}</b>
                      <div class="pt">{{ $t('feedback.ExpectedPriority') }}</div>
                    </div>
                    <div class="p">
                      <div class="b">{{ content.productName }}&nbsp;&nbsp;{{ content.versionNo }}</div>
                      <div class="pt">{{ $t('feedback.proName') }}</div>
                    </div>
                    <div class="p">
                      <b>{{ content.status || 'NEW' }}</b>
                      <div class="pt">{{ $t('admin.problemStatus') }}</div>
                    </div>
                    <div class="p" v-if="false">
                      <b>{{ content.expectedResolutionTime || '&nbsp;' }}</b>
                      <div class="pt">{{ $t('feedback.ExpectedResolutionTime') }}</div>
                    </div>
                    <div class="p">
                      <b>{{ content.time || '&nbsp;' }}</b>
                      <div class="pt">{{ $t('feedback.createDate') }}</div>
                    </div>
                    <div class="p">
                      <b>{{ content.updateTime || '&nbsp;' }}</b>
                      <div class="pt">{{ $t('feedback.updateTime') }}</div>
                    </div>
                    <div class="p" style="opacity: 0;"></div>
                  </div>
                </div>
        </div>
      </div>
      <!-- 我的产品 -->
      <div class="item">
        <div class="text bd10 p3">
          <!-- <div class="schedule d-flex j-center">
						<div class="d-flex j-center pr">
							<p class="active">
								<span>01</span>
								节点一
							</p>
							<p>
								<span>02</span>
								节点二
							</p>
							<p>
								<span>03</span>
								节点三
							</p>
							<p>
								<span>04</span>
								节点四
							</p>
						</div>
					</div> -->
          <div class="problemList">
            <ul>
              <li>
                
                <div class="supplement">
                  
                  <div class="supi d-flex">
                    <div class="it font-light">{{$store.state.member.sexual}}{{$store.state.member.name}}</div>
                    <div class="supp line-sm font-light">
                      <div class="supt">
                        <div class="tt">{{content.title}}</div>
                        <div class="txt" v-html="content.description"></div>
                        <div class="imgs d-flex" v-if="content.file">
                          <a :href="i" download="" class="i2 d-flex" v-for="(i,index) in content.file.split(',')">
                            <span class="el-icon-document"></span>
                          </a>
                        </div>
                        <div class="ibot"><span>{{content.time}}</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="supi d-flex" v-for="(i, index) in content.detailsList" :key="index">
                    <div class="it font-light">{{ isSystemUser(i.personnel)?($store.state.member.sexual+$store.state.member.name):"UVOS" }}</div>
                    <div class="supp line-sm font-light">
                      <div class="supt">
                        <div class="txt" v-html="i.description"></div>
                        <div class="ibot">
                          <span>{{ i.createTime }}</span><span class="btn" v-if="!disabledStatus.includes(content.status)" @click="addApplay(i.tId, i.id)">回复</span>
                        </div>
                        <div class="editor" v-if="applayForm.id == i.tId">
                          <quill-editor class="qeditor" ref="myQuillEditor" v-model="applayForm.description"
                            :options="editorOption" />
                          <div class="editorBtns">
                            <el-button type="primary" @click="submitApplay(i.tId)">{{ $t('commom.ok') }}</el-button>
                            <el-button @click="clearApplayForm">{{ $t('commom.cancel') }}</el-button>
                          </div>
                        </div>
                      </div>
                      <div class="child" v-if="i.children && i.children.length > 0">
                        <div class="supi d-flex" v-for="j in i.children">
                          <div class="it font-light">{{ isSystemUser(j.personnel)?($store.state.member.sexual+$store.state.member.name):"UVOS" }}</div>
                          <div class="supp2  line-sm font-light">
                            <div class="supt">
                              <div class="txt" v-html="j.description"></div>
                              <div class="ibot">
                                <span>{{ j.createTime }}</span><span v-if="!disabledStatus.includes(content.status)" class="btn" @click="addApplay(j.tId, j.parentId)">回复</span>
                              </div>
                              <div class="editor" v-if="applayForm.id == j.tId">
                                <quill-editor class="qeditor" ref="myQuillEditor" v-model="applayForm.description"
                                  :options="editorOption" />
                                <div class="editorBtns">
                                  <el-button type="primary" @click="submitApplay(j.tId)">{{ $t('commom.ok') }}</el-button>
                                  <el-button @click="clearApplayForm">{{ $t('commom.cancel') }}</el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="addedit" v-if="!disabledStatus.includes(content.status)">
                  <div class="it font-light">{{ $t('admin.supplementaryQuestions') }}:</div>
                  <div class="editor">
                    <quill-editor class="qeditor" ref="myQuillEditor2" v-model="addForm.description"
                      :options="editorOption2" />
                    <div class="editorBtns d-flex">
                      <el-button type="primary" @click="submitAddForm">{{ $t('commom.ok') }}</el-button>
                      <el-button @click="clearAddForm">{{ $t('commom.cancel') }}</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="hideFile" style="display: none;">
              <input type="file" ref="uploadbtn" @change="uploadFile">
              <input type="file" ref="uploadbtn2" @change="uploadFile2">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="supplypop" style="display: none;">
      <div class="popin d-flex a-center j-center">
        <div class="box">
          <div class="poptit d-flex a-center j-sb">
            <div class="t">{{ $t('admin.supplementaryQuestions') }}</div>
            <div class="close pointer" @click="showPop = false">
              <img src="@/assets/Icons/closeNew.png" alt="" />
            </div>
          </div>
          <div class="popcontent">
            <div class="popform">
              <div class="line">
                <div class="label">
                  <span>{{ $t('admin.supplementaryQuestions') }}</span><span class="blue">*</span>
                </div>
                <div class="in">
                  <input type="text" v-model="formData.title" :placeholder="$t('admin.problemSummaryPlaceholder')" />
                </div>
              </div>
              <div class="line">
                <div class="label">
                  <span>{{ $t('admin.problemDetails') }}</span><span class="blue">*</span>
                </div>
                <div class="in">
                  <textarea v-model="formData.description" :placeholder="$t('admin.problemDetailsPlaceholder')"></textarea>
                </div>
              </div>
              <div class="line">
                <div class="label"><span>{{ $t('admin.uploadAttachments') }}</span></div>
                <div class="in">
                  <div class="fileUpload d-flex f-wrap">
                    <div
                      class="fileBtn pr d-flex f-colu a-center j-center t-center cor999 font-light"
                    >
                      <input type="file" class="ab opacity0 pointer" />
                      <img src="@/assets/Icons/add.png" alt="" />
                      {{ $t('admin.addImages') }}
                      <el-upload
                        class="avatar-uploader ab"
                        action="/api/common/file/upload"
                        :multiple="false"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :headers="{
                          InterfaceToken: $store.state.InterfaceToken,
                        }"
                      >
                      </el-upload>
                    </div>
                    <div
                      class="fileBtn pr"
                      v-for="(img, index) in formData.file"
                      :key="index"
                    >
                      <img :src="img" class="w100" alt="" />
                      <span class="del pointer" @click="removeImg(index)"
                        ><img src="@/assets/Icons/del.png" alt=""
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btns">
                 <div class="btn" @click="submit">{{ $t('admin.submit') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
import quillEmoji from 'quill-emoji'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-emoji/dist/quill-emoji.css'
import { Upload } from 'element-ui'
Quill.register('modules/ImageExtend', ImageExtend)
export default {
  name: "EnterDetail",
  components: { quillEditor },
  data() {
    return {
      selectPriority:[],
      editorOption: {
        theme: 'snow',
        placeholder:this.$t('commom.editorPlaceholder'),
        modules: {
          "emoji-toolbar": true,
          "emoji-shortname": true,
          toolbar: {
            container: [
              ['emoji', 'clean', 'link']
            ]
          }
        }
      },
      editorOption2: {
        theme: 'snow',
        placeholder:this.$t('commom.qsPlaceholder'),
        modules: {
          "emoji-toolbar": true,
          "emoji-shortname": true,
          toolbar: {
            container: [
              ['emoji', 'clean', 'link']
            ]
          }
        }
      },
      // 详细信息
      showPop: false,
      //回复表单
      applayForm: {
        feedbackId: "",
        id: "",
        parentId: "",
        description: "",
      },
      addForm: {
        feedbackId: "",
        description: "",
      },
      formData: {
        feedbackId: "",
        title: "", // 标题
        description: "", // 描述
        file: [], // 附件
      },
      disabledStatus:['Closed'],
      itemid: "",
      content: {
        detailsList: {
          title: "",
        },
      },
    };
  },

  created() {
    // 获取详细信息
    this.itemid = this.$route.query.id;
    this.applayForm.feedbackId = this.itemid;
    this.addForm.feedbackId = this.itemid;
    this.getContentInfo(this.itemid);
    this.getCostomerPriority();
  },
  filters:{
    valueToLabel:function(value,arr){
		if(value!=null&&arr&&arr.length>0){
			var a=arr.filter(i=>{return i.value==value});
			return a[0]?.label||'';
		}else{
			return ''
		};
		
	}
  },
  methods: {
    isSystemUser(name){
      if(!name){
        return false
      };
      const sysArr=['uvos_admin','uvos','customer',"customer(uvos)",'customer (uvos)'];
      return sysArr.includes(name.trim().toLowerCase())
    },
    getCostomerPriority(){//获取优先级数据字典
		this.$axios.get(`common/getDict?dictType=sys_feedback_priority`)
		  .then(res => {
			  this.selectPriority=res.data;
		  })
		  .catch(err=>{})
	  },
    submitApplay() {
      var that = this;
      if (!that.applayForm.description) {
        that.$message({
          message: this.$t('admin.enterDetail'),
          type: "warning"
        });
        return;
      };
      var data = new FormData();
      Object.keys(that.applayForm).forEach(function (key) {
        data.append(key, that.applayForm[key]);
      });
      this.$axios({
        method: 'post',
        url: 'member/addFeedbackReply',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data,
      }).then(res => {
        this.$message({
          message: this.$t('commom.saveSuccess'),
          type: 'success'
        });
        that.getContentInfo(that.itemid);
        that.clearApplayForm();
      })
        .catch(err => { });
    },
    clearApplayForm() {
      this.applayForm.description = '';
      this.applayForm.id = '';
      this.applayForm.parentId = '';
    },
    submitAddForm() {
      var that = this;
      if (!that.addForm.description) {
        that.$message({
          message: this.$t('admin.enterDetail'),
          type: "warning"
        });
        return;
      };
      var data = new FormData();
      Object.keys(that.addForm).forEach(function (key) {
        data.append(key, that.addForm[key]);
      });
      this.$axios({
        method: 'post',
        url: 'member/addFeedbackDetails',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data,
      }).then(res => {
        this.$message({
          message: this.$t('commom.saveSuccess'),
          type: 'success'
        });
        that.getContentInfo(that.itemid);
        that.clearAddForm();
      })
        .catch(err => { });
    },
    clearAddForm() {
      this.addForm.description = ''
    },
    showAdd() {
      this.showPop = true;
      this.applayForm.description = '';
      this.applayForm.id = '';
      this.applayForm.parentId = '';
    },
    imageUpload(state) {
      if (state) {
        this.$refs.uploadbtn.click();
      }
    },
    imageUpload2(state) {
      if (state) {
        this.$refs.uploadbtn2.click();
      }
    },
    uploadFile(e) {
      var formdata = new FormData();
      let type = e.target.files[0].type.split('/')[0];
      let fname = e.target.files[0].name;
      formdata.append("file", e.target.files[0]);
      this.$axios({
        method: 'post',
        url: '/common/file/upload',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formdata,
      }).then(res => {
        switch (type) {
          case 'image': {
            let selection = this.$refs.myQuillEditor[0].quill.getSelection();
            this.$refs.myQuillEditor[0].quill.insertEmbed(selection != null ? selection.index : 0, 'image', res.data)
            this.$refs.myQuillEditor[0].quill.setSelection(selection.index + 1);
            break;
          };
          case 'video': {
            let selection = this.$refs.myQuillEditor[0].quill.getSelection();
            this.$refs.myQuillEditor[0].quill.insertEmbed(selection != null ? selection.index : 0, 'video', res.data)
            this.$refs.myQuillEditor[0].quill.setSelection(selection.index + 1);
            break;
          };
          default: {
            let selection = this.$refs.myQuillEditor[0].quill.getSelection();
            this.$refs.myQuillEditor[0].quill.clipboard.dangerouslyPasteHTML(selection != null ? selection.index : 0, '<a href="' + res.data + '">' + fname + '</a>', 'api')
            this.$refs.myQuillEditor[0].quill.setSelection(selection.index + 2);
            break;
          }
        }
      })
    },
    uploadFile2(e) {
      var formdata = new FormData();
      let type = e.target.files[0].type.split('/')[0];
      let fname = e.target.files[0].name;
      formdata.append("file", e.target.files[0]);
      this.$axios({
        method: 'post',
        url: '/common/file/upload',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formdata,
      }).then(res => {
        switch (type) {
          case 'image': {
            let selection = this.$refs.myQuillEditor2.quill.getSelection();
            this.$refs.myQuillEditor2.quill.insertEmbed(selection != null ? selection.index : 0, 'image', res.data)
            this.$refs.myQuillEditor2.quill.setSelection(selection.index + 1);
            break;
          };
          case 'video': {
            let selection = this.$refs.myQuillEditor2.quill.getSelection();
            this.$refs.myQuillEditor2.quill.insertEmbed(selection != null ? selection.index : 0, 'video', res.data)
            this.$refs.myQuillEditor2.quill.setSelection(selection.index + 1);
            break;
          };
          default: {
            let selection = this.$refs.myQuillEditor2.quill.getSelection();
            this.$refs.myQuillEditor2.quill.clipboard.dangerouslyPasteHTML(selection != null ? selection.index : 0, '<a href="' + res.data + '">' + fname + '</a>', 'api')
            this.$refs.myQuillEditor2.quill.setSelection(selection.index + fname.length);
            break;
          }
        }
      })
    },
    addApplay(id, pid) {
      this.applayForm.description = '';
      this.applayForm.parentId = pid;
      this.applayForm.id = id;
      this.$nextTick(function () {
        if (this.$refs.myQuillEditor[0]) {
          this.$refs.myQuillEditor[0].quill.getModule('toolbar').addHandler('clean', this.imageUpload);
        };
      })
    },
    // 获取详细信息
    getContentInfo(id) {
      this.$axios
        .get(`member/feedbackDetails?id=${id}`)
        .then((res) => {
          this.content = res.data;
        })
        .catch((err) => { });
    },
    beforeAvatarUpload(file) {
      this.beforeAvatarUploadCommon(file);
    },
    removeImg: function (index) {
      this.formData.file.splice(index, 1);
    },
    // 上传成功
    handleAvatarSuccess(response) {
      if (response.code == 500) {
        this.$message.error(this.$t('commom.sysErr'));
      }
      this.formData.file.push(response.data);
    },
    addsuply(id) {
      var that = this;
      that.showPop = true
    },
    submit() {
      var that = this;
      if (!that.formData.title) {
        that.$message({
          message: this.$t('admin.enterQuestion'),
          type: 'warning'
        });
        return;
      };
      if (!that.formData.description) {
        that.$message({
          message: this.$t('admin.enterDetail'),
          type: "warning"
        });
        return;
      };
      var data = new FormData();
      Object.keys(that.formData).forEach(function (key) {
        data.append(key, that.formData[key]);
      });
      this.$axios({
        method: 'post',
        url: 'member/addFeedbackDetails',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data,
      }).then(res => {
        this.$message({
          message: this.$t('commom.saveSuccess'),
          type: 'success'
        });
        that.getContentInfo(that.itemid);
        that.showPop = false;
      })
        .catch(err => { });
    }
  },
  mounted: function () {
    var that = this;
    if (that.$refs.myQuillEditor2) {
      that.$refs.myQuillEditor2.quill.getModule('toolbar').addHandler('clean', that.imageUpload2);
    }

  }
};
</script>

<style lang="less" scoped>
/deep/.ql-editor {
  min-height: 120px;
}
/deep/.ql-editor.ql-blank:before {
    color: #ccc;
}
.sdesc {
  border-radius: 0.05rem;
  background: #fff;
  line-height: 2;
  .txt {
    flex-wrap: wrap;
    padding: 0 0.15rem;
    .p {
      flex: 0 0 auto;
      width: 20%;
      padding-left: 15px;
      border-left: 3px solid #2657db;
      line-height: 1.1;
      margin: 20px 0;
      b{
        display: block;
        margin-bottom: 10px;
        line-height: 1.1;
        min-height: 1.1em;
      }
      .b{
        font-weight: bold;
        margin-bottom: 10px;
        line-height: 1.1;
      }
      .pt{
        line-height: 1.1;
      }
      &:nth-child(4n){
        width: 40%;
      }
    }
    @media (max-width:768px) {
      display: block;
      padding: 0;
      .p{
      width: auto !important;
      border-width: 1px;
    }
    }
    
  }
  @media (max-width:640px) {
    padding: 0 .15rem;
  }
}

.flis .i {
  color: #2657db;
  text-decoration: underline;
  margin-bottom: 5px;

  a {
    color: #2657db;
  }
}

.supplement {
  padding: 0.1rem 0.2rem;
  border-radius: 0.05rem;
  background: #fff;
  margin-bottom: 0.1rem;

  .supi {
    align-items: flex-start;
    margin-bottom: .2rem;
    .it {
      flex: 0 0 auto;
      width: 7em;
      line-height: 0.3rem;
      color: #2657db;
    }
    .supp{
      flex: 1 1 auto;
      padding-left: .2rem;
      border-left: 1px solid #e0e0e0;
      overflow: hidden;
      .tt{
        line-height: .3rem;
        font-weight: bold;
        font-size: .2rem;
        margin-bottom: .1rem;
      }
      @media (max-width: 640px) {
        padding-left: 0;
        border: none;
      }
    }
    .supp2{
      flex: 1 1 auto;
      padding-left: .2rem;
      overflow: hidden;
      border-left: 1px solid #e0e0e0;
      @media (max-width: 640px) {
        padding-left: 0;
        border: none;
      }
    }
    .supt {
      padding-bottom: 0.16rem;
      &:last-child{
        padding-bottom: 0;
      }
      .txt {
        font-size: .18rem;
        color: #000;
        line-height: .3rem;
        padding-bottom: .1rem;
        /deep/a {
          color: #2657db;
          text-decoration: underline;
        }
      }
      .pdate{
        color: #999;
        font-size: .14rem;
      }

      .supt2 {
        margin-bottom: 0.1rem
      }

      .ibot {
        font-size: 0.9em;
        color: #666;

        span {
          margin-right: 0.1rem;
          cursor: pointer;
          &.btn{
            color: #2657db;
          }
        }
      }

      .editor {
        margin-top: 0.1rem;
      }
      .imgs{
        flex-wrap: wrap;
        align-items: stretch;
        .i2{
          width: 50px;
          height: 50px;
          background: #f2f5fa;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          font-size: 22px;
          margin-right: .1rem;
          margin-bottom: .1rem;
        }
        .i{
          flex: 0 0 auto;
          width: 80px;
          height: 80px;
          background: #f2f5fa;
          margin-right: .1rem;
          margin-bottom: .1rem;
          border-radius: .1rem;
          overflow: hidden;
          img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    @media (max-width:768px) {
      display: block;
      .it{
        width: auto;
        margin-bottom: 10px;
      }
    }
  }

  .child {
    background: #f2f5fa;
    padding: 0.2rem;
    border-radius: 0.05rem;

    .supt {
      padding-bottom: 0.1rem;

      .cit {
        margin-bottom: 5px;
      }

      .txt {
        /deep/a {
          color: #2657db;
          text-decoration: underline;
        }
      }

      &:not(:last-child) {
        margin-bottom: 0.1rem;
      }
    }
    .editor{
      background: #fff;
      border-radius: .1rem;
      padding-bottom: 70px;
      /deep/.ql-toolbar.ql-snow{
        background: #fff;
        border:none;
        border-bottom: 1px solid #f2f5fa;
        border-radius: .1rem .1rem 0 0;
      }
      /deep/.ql-container.ql-snow{
        padding: 0 .15rem;
      }
      .editorBtns{
        right: .15rem;
        bottom: 10px;
      }
    }
  }
  
}
/deep/.quill-editor{
  background: none;
  border: 1px solid #dadada;
  border-radius: 10px;
}
.editor{
    position: relative;
    padding-bottom: 60px;
    .editorBtns {
      line-height: 1;
      position: absolute;
      right: 0;
      bottom: 0;
      /deep/span {
        line-height: 1
      }
      @media(max-width:640px){
        /deep/.el-button {font-size: 12px;padding: 8px 15px;}
      }
    }
    /deep/.ql-container{
      font-size: inherit;
      font-family: inherit;
    }
    /deep/.ql-editor{
      padding: .1rem .15rem;
    }
    /deep/.ql-toolbar.ql-snow,/deep/.ql-container.ql-snow {
        border: none;
    }

    /deep/.ql-toolbar.ql-snow {
        background: #f2f5fa;
        border-bottom: 1px solid #dadada !important;
        border-bottom: none;
        border-radius: 10px 10px 0 0;
    }
  }
.addedit {
  margin-top: 0.2rem;
  padding: 0.15rem;
  border-radius: 0.05rem;
  background: #fff;

  .it {
    margin-bottom: 0.1rem;
  }
}

.fileUpload {
  margin-top: -0.2rem;

  .fileBtn {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.2rem;
    margin-top: 0.2rem;

    .del {
      position: absolute;
      right: 0.1rem;
      top: 0.1rem;
      width: 0.2rem;
      z-index: 3;
    }

    &:nth-of-type(1) {
      img {
        width: 0.3rem;
        margin-bottom: 0.15rem;
      }

      background: #f5f6f8;
    }
  }
}

.personHome {
  .topTitle {
    margin-bottom: 0.1rem;

    .sTitle {
      margin-bottom: 0;

      h3 {
        width: 80%;
      }
    }
  }

  .psLeftContent {
    .item{
      margin-bottom: .1rem;
    }
    .problemList {
      ul {
        li {
          border-radius: 0.1rem;
          margin-bottom: 0.1rem;
          h3 {
            .t {
              padding: 0 0.1rem;
              height: 0.3rem;
              border-radius: 0.3rem;
              background: #2657db;
              color: #fff;
              margin-right: 0.1rem;
              line-height: 0.3rem;
            }

            .btn {
              padding: 0 0.15rem;
              border-radius: 0.3rem;
              border: 1px solid #2657db;
              color: #2657db;
              border-radius: 0.3rem;
              line-height: 0.34rem;
              font-size: 0.16rem;
              cursor: pointer;

              &:hover {
                background: #2657db;
                color: #fff;
              }
            }
          }

          @media (max-width:640px) {
            .hl {
              display: block;

              .t {
                display: inline-block;
              }

              .t2 {
                display: block;
                margin-top: 5px;
                color: #999;
              }
            }
          }

          p {
            padding: 0.15rem;
            border-radius: 0.05rem;
            background: #fff;
            margin-bottom: 5px;
          }

          .supplement {
            .t {
              padding: 0.26rem 0 0.16rem;
            }
          }
        }
      }
    }

    .schedule {
      padding: 0.3rem 0;

      >div:after {
        content: "";
        position: absolute;
        top: 0.25rem;
        width: 100%;
        height: 2px;
        background: #ced3de;
        z-index: 1;
      }

      p {
        position: relative;
        z-index: 2;

        span {
          display: block;
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          color: #fff;
          background: #ced3de;
          text-align: center;
          line-height: 0.3rem;
          border: solid 0.1rem #fff;
          margin: 0 auto 0.1rem;
        }

        &.active span {
          background: #2657db;
        }

        &:not(:last-child) {
          margin-right: 1.15rem;
        }
      }
    }
  }

  @media (max-width: 640px) {
    padding: 0.2rem;

    .topTitle {
      position: relative;
      padding-top: 0.25rem;
      padding-bottom: .25rem
    }

    .psLeftContent {
      .schedule {
        p {
          &:not(:last-child) {
            margin-right: 0.5rem;
          }
        }
      }
      .item{
        .text{
          padding: 5px;
        }
      }
    }
  }
}

.supplypop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.6);

  .popin {
    width: 100%;
    height: 100%;

    .box {
      width: 800px;
      max-width: 94%;
      background: #fff;
      border-radius: 8px;

      .poptit {
        background: #f5f6f8;
        padding: .2rem .28rem;
        border-radius: 8px 8px 0 0;

        .t {
          font-size: .26rem;
          color: #000;
        }
      }

      .popcontent {
        padding: .28rem .28rem .35rem;

        .line {
          margin-bottom: .24rem;

          .label {
            margin-bottom: .15rem;

            .blue {
              padding-left: .1rem;
              color: #2e70e2;
            }
          }

          .in {
            input {
              width: 100%;
              padding: 0 .2rem;
              height: .5rem;
              background: #f5f6f8;
              border: none;
              outline: none;
              color: inherit;
              font-family: inherit;
              font-size: inherit;
            }

            textarea {
              width: 100%;
              padding: .2rem;
              height: 1.2rem;
              resize: none;
              background: #f5f6f8;
              border: none;
              outline: none;
              color: inherit;
              font-family: inherit;
              font-size: inherit;
            }
          }
        }

        .btns {
          .btn {
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            min-width: 1.2rem;
            padding: 0 .2rem;
            text-align: center;
            line-height: .5rem;
            background: #294ad3;
            border-radius: 4px;
            color: #fff;

            &:hover {
              background: #4768ef;
            }
          }
        }
      }
    }
  }
}
</style>
